/**
 * @deprecated change by routeutils.getContext
 */
export const getContext = (): string => {
    const hostname = window.location.hostname;

    if (hostname.includes('backoffice-be')) {
        return 'backoffice';
    } else if (hostname.includes('backoffice-nl')) {
        return 'backofficenl';
    } else if (hostname.includes('backoffice-ci')) {
        return 'cibo';
    } else if (hostname.includes('backoffice-govex')) {
        return 'govexbo';
    } else if (hostname.includes('vbk')) {
        return 'vbk';
    }

    return 'backoffice'; // Default context
}; 